<div class="modal-header">
    <h4 class="modal-title"> Cihaz {{data.message}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body col-12">
    <form [formGroup]="deviceForm">
        <div class="row">
            <!-- Firma Seçimi -->
            <div class="col-xl-4 col-md-6 col-sm-12 col-12">
                <label for="companyId">Firma</label>
                <ng-select [items]="companies" bindLabel="companyName" bindValue="id"
                    formControlName="companyId"></ng-select>
                <div *ngIf="deviceForm.get('companyId').invalid && deviceForm.get('companyId').touched"
                    class="text-danger">
                    Firma zorunludur.
                </div>
            </div>

            <div class="col-xl-4 col-md-6 col-sm-12 col-12">
                <label for="companyPersonId">Firma Yetkili Kişi</label>
                <div class="form-group">
                    <ng-select [bindValue]="'id'" formControlName="companyPersonId">
                        <ng-option *ngFor="let user of companyPersons" [value]="user.id">{{user.name + ' ' +
                            user.lastName}}</ng-option>
                    </ng-select>
                    <div *ngIf="deviceForm.get('companyPersonId').invalid && deviceForm.get('companyPersonId').touched"
                        class="text-danger">
                        Cihaz Yetkili Kişisi Zorunludur.
                    </div>
                </div>
            </div>

            <div class="col-xl-4 col-md-6 col-sm-12 col-12">
                <div class="col-12">
                    <label for="startDate">Hareket Tarihi</label>
                    <div class="form-group">
                        <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" [setDate]="date"
                            formControlName="movementDate"></ng2-flatpickr>
                    </div>
                </div>

            </div>

            <div class="col-xl-12 col-md-6 col-sm-12 col-11">
                <label for="selectedDevices">Firma Cihazları</label>

                <ng-select #selectMultiLimited [multiple]="true" formControlName="selectedDevices">
                    <ng-option *ngFor="let device of companyDevice" [value]="device.id">
                        {{device.brandName + ' ' + device.modelName + ' ' + device.seriNo }}
                    </ng-option>
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                        <span class="ng-value-label"> {{ findDeviceById(item) }} </span>
                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                    </ng-template>
                </ng-select>
            </div>

        </div>

        <!-- Ürünler -->
        <div formArrayName="createDevicesList" class="mt-1">
            <h5>Yeni Cihaz Girişi</h5>
            <div *ngFor="let product of createDevicesList.controls; let i = index" [formGroupName]="i" class="row mt-2">
                <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                    <label for="kindId">Cihaz Türü</label>
                    <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId"></ng-select>
                </div>

                <div class="col-xl-3 col-md-5 col-sm-11 col-12">
                    <label for="brandModalId">Marka & Model</label>
                    <div class="form-group">
                        <ng-select [items]="brands" [searchFn]="searchFn" bindLabel="name" bindValue="id"
                            groupBy="brandName" formControlName="brandModelId">
                            <ng-template ng-optgroup-tmp let-item="item">
                                {{ item.brandName || 'Bilinmeyen Marka' }}
                            </ng-template>
                        </ng-select>
                        <div *ngIf="deviceForm.get('brandModalId')?.invalid && deviceForm.get('brandModalId')?.touched"
                            class="text-danger">
                            Model seçmek zorunludur.
                        </div>
                    </div>
                </div>

                <div class="col-xl-3 col-md-6 col-sm-12 col-12">
                    <label for="seriNo">Seri No</label>
                    <input type="text" class="form-control" formControlName="seriNo" maxlength="30" />
                </div>

                <div class="col-xl-2 col-md-6 col-sm-12 col-12">
                    <label for="inventoryNumber">Envanter No</label>
                    <input type="text" class="form-control" formControlName="inventoryNumber" />
                </div>

                <div class="col-xl-1 col-md-1 col-sm-12 col-12 mt-2">
                    <button type="button" class="btn btn-icon btn-flat-danger" (click)="removeProduct(i)" rippleEffect>
                        <span [data-feather]="'trash'"></span>
                    </button>
                </div>
                <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                    <label for="basicTextarea">Cihaz Açıklama</label>
                    <fieldset class="form-group">
                      <textarea class="form-control" id="basicTextarea" placeholder="Cihaz açıklaması" formControlName="description"></textarea>
                    </fieldset>
                </div>
            </div>
        </div>
        <div>
            <button type="button" class="btn btn-primary mt-2" (click)="addProduct()">+</button>
        </div>


        <label for="basicTextarea">Hareket Açıklaması</label>
        <textarea class="form-control" formControlName="description" id="basicTextarea" rows="1"
            placeholder="Cihaz hareket açıklaması giriniz."></textarea>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" [disabled]="!deviceForm.valid" (click)="onSubmit()">Kaydet</button>
</div>